import {
  AuthService,
  FlexContainer,
  StatusCircle,
  TableContainer,
  TableData,
  TableHead,
  TableRow,
  TBody,
  THead,
} from "@mindmemobile/mm-shared-global";
import React, { FC } from "react";
import { Table } from "react-bootstrap";
import { ProductAttributeInputModel } from "../../../../../shared/models";
import styled from "styled-components"; 

export const ImgWrapper = styled.div`
  height: 90px;
  width: 65px;
  border-radius: 4px;
  img {
    height: 100%;
    width: 100%;
  }
`;
type ITableProps = {
  variants: ProductAttributeInputModel;
  onClick: (index: number) => void;
  selectedVariantIndex: number;
};

export const VariantTable: FC<ITableProps> = ({
  selectedVariantIndex,
  variants,
  onClick,
}) => {
  return (
    <TableContainer>
      <Table cellSpacing="20" className="table item-variant-table">
        <THead>
          <TableHead>VARIANT</TableHead>
          <TableHead className="text-right">ON HAND</TableHead>
        </THead>
        <TBody fromPaymentSystem={AuthService.fromPaymentSystem}>
          {variants.options.map((option, idx) => {
            const selectedClasss =
              selectedVariantIndex === idx ? "selected" : "";
            return (
              <TableRow key={idx} onClick={() => onClick(idx)}>
                <TableData className="table-col-70">
                  <FlexContainer alignItems="center" spacing={10}>
                    <StatusCircle
                      heightWidth="16px"
                      // bgColor="#aaa"
                    />
                    <div
                      className={`${selectedClasss} flex-auto-grow overflow-ellipsis`}
                    >
                      {option.name}
                    </div>
                  </FlexContainer>
                </TableData>
                <TableData className={`text-right ${selectedClasss}`}>
                  {option.onHand}
                </TableData>
              </TableRow>
            );
          })}
        </TBody>
      </Table>
    </TableContainer>
  );
};
